// memory-usage-plugin.ts
import { registerPlugin } from "@capacitor/core";

export interface MemoryInfo {
    /**
     * Mémoire utilisable de l'application en mégaoctets (Mo).
     */
    usableMemory: number;

    /**
     * Mémoire utilisable étendue de l'application en mégaoctets (Mo), destinée aux applications nécessitant plus de mémoire.
     */
    usableLargeMemory: number;

    /**
     * Mémoire actuellement utilisée par l'application en mégaoctets (Mo).
     */
    memoryUsed: number;
}

export interface MemoryUsagePlugin {
    getComprehensiveMemoryInfo(): Promise<any>;
}

const MemoryUsagePlugin = registerPlugin<MemoryUsagePlugin>("MemoryUsagePlugin");

export { MemoryUsagePlugin };